import React from 'react';
import PropTypes from 'prop-types';
import SelectionSingleSelectItem from '@/components/ui/SelectionSingleSelectItem';
import { XMarkIcon} from '@heroicons/react/24/outline';

export default function SelectionSingleSelectGroup(props) {
  const {
    label,
    options = [],
    value = null,
    onChange = () => {},
    onClear = null
  } = props;
  return (
    <div role="radiogroup" aria-label={label}>
      {label && (
        <p className="text-sm text-gray-600 mb-3">{label}</p>
      )}
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <SelectionSingleSelectItem
            key={option}
            label={option}
            selected={value === option}
            onChange={() => onChange(option)}
          />
        ))}
        {onClear && (
          <button type="button" onClick={onClear} aria-label="Clear selection">
            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
}

SelectionSingleSelectGroup.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
};
